module.exports = __webpack_public_path__ + "static/media/orange_attention.0d3326a8.svg";